export const STALE_TIME = 24 * 60 * 60 * 1000; // 24 hours
export const DEFAULT_QUERY_OPTIONS = {
    staleTime: STALE_TIME
};